// Drop-in replacement for the old axios client. The pages still call
// api.get("/expenses") etc., but instead of going to the FastAPI server the
// requests are answered from the encrypted on-device vault.
import { getState, update } from "./vault";

const COLLECTIONS = {
  expenses: { key: "expenses" },
  debts: { key: "debts", sortBy: "date" },
  wealth: { key: "wealth", sortBy: "month" },
};

const newId = () => crypto.randomUUID();
const ok = (data) => Promise.resolve({ data: structuredClone(data) });

function parse(path) {
  const [, name, id] = path.split("/");
  return { name, id };
}

function list(name) {
  const { key, sortBy } = COLLECTIONS[name];
  const items = [...getState()[key]];
  if (sortBy) items.sort((a, b) => a[sortBy].localeCompare(b[sortBy]));
  return items;
}

function notFound() {
  return Promise.reject(Object.assign(new Error("Not found"), { status: 404 }));
}

export const api = {
  get(path) {
    const { name } = parse(path);
    if (name === "income") return ok(getState().income);
    if (COLLECTIONS[name]) return ok(list(name));
    return notFound();
  },

  async post(path, body) {
    const { name } = parse(path);
    if (!COLLECTIONS[name]) return notFound();
    const item = { id: newId(), ...body };
    await update((s) => {
      s[COLLECTIONS[name].key].push(item);
    });
    return { data: item };
  },

  async put(path, body) {
    const { name, id } = parse(path);
    if (name === "income") {
      await update((s) => {
        s.income = { ...body };
      });
      return { data: body };
    }
    if (!COLLECTIONS[name]) return notFound();
    const items = getState()[COLLECTIONS[name].key];
    if (!items.some((x) => x.id === id)) return notFound();
    const item = { ...body, id };
    await update((s) => {
      const arr = s[COLLECTIONS[name].key];
      arr[arr.findIndex((x) => x.id === id)] = item;
    });
    return { data: item };
  },

  async delete(path) {
    const { name, id } = parse(path);
    if (!COLLECTIONS[name]) return notFound();
    await update((s) => {
      const k = COLLECTIONS[name].key;
      s[k] = s[k].filter((x) => x.id !== id);
    });
    return { data: { ok: true } };
  },
};

export const currency = (n) =>
  new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    maximumFractionDigits: 2,
  }).format(Number(n) || 0);
